<script setup lang="ts">
  import { useTranslation } from '@/composables/useTranslation'
  import { X } from 'lucide-vue-next'

  defineEmits<{
    dismiss: []
  }>()

  const { t } = useTranslation({
    en: {
      Title: 'Court database in AI chat',
      Body:
        'Our AI searches relevant case law for you and surfaces matching verdicts directly ' +
        'in the chat. Just enable the court database.',
      Done: 'Done'
    },
    de: {
      Title: 'Urteilsdatenbank im KI-Chat',
      Body:
        'Unsere KI durchsucht für Sie relevante Rechtsprechung und zeigt passende Urteile ' +
        'direkt im Chat an. Aktivieren Sie dafür einfach die Urteilsdatenbank.',
      Done: 'Fertig'
    },
    fr: {
      Title: 'Base de données des décisions dans le chat IA',
      Body:
        'Notre IA recherche pour vous la jurisprudence pertinente et affiche les décisions ' +
        'correspondantes directement dans le chat. Activez simplement la base de données des décisions.',
      Done: 'Terminé'
    }
  })
</script>

<template>
  <div
    class="w-[286px] rounded-[8px] border border-gray-200 bg-white p-3
      shadow-[0_4px_8px_rgba(0,0,0,0.08),0_8px_12px_rgba(0,0,0,0.08)]"
    data-cy="verdict-feature-hint"
  >
    <div class="flex items-center gap-2">
      <div class="flex min-w-0 flex-1 items-center gap-1">
        <!-- Megaphone icon — inlined from original Figma asset -->
        <svg
          class="size-5 shrink-0"
          viewBox="0 0 16.5 16.9562"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.91667 10.3894V3.7227M9.91667 10.3894L15.0017 13.2952C15.0777 13.3387 15.1637 13.3614 15.2513 13.3612C15.3388 13.361 15.4248 13.3378 15.5006 13.2939C15.5763 13.25 15.6392 13.187 15.683 13.1112C15.7268 13.0354 15.7499 12.9494 15.75 12.8619V1.2502C15.75 1.16257 15.727 1.07648 15.6833 1.00054C15.6396 0.924606 15.5767 0.86149 15.5009 0.817518C15.4251 0.773546 15.3391 0.750263 15.2515 0.750002C15.1639 0.749741 15.0777 0.772511 15.0017 0.816029L9.91667 3.7227M9.91667 3.7227H4.08333C3.19928 3.7227 2.35143 4.07389 1.72631 4.69901C1.10119 5.32413 0.75 6.17197 0.75 7.05603C0.75 7.94008 1.10119 8.78793 1.72631 9.41305C2.35143 10.0382 3.19928 10.3894 4.08333 10.3894M9.91667 10.3894H4.08333M4.08333 10.3894L4.71417 14.806C4.77999 15.2357 5.01273 15.6221 5.36182 15.8812C5.71091 16.1403 6.14814 16.2511 6.57849 16.1896C7.00884 16.1281 7.39754 15.8993 7.66013 15.5529C7.92271 15.2064 8.03796 14.7703 7.98083 14.3394L7.41667 10.3894H4.08333Z"
            stroke="#1F2937"
            stroke-width="1.5"
          />
        </svg>
        <p class="flex-1 whitespace-nowrap text-sm font-semibold leading-5 text-black">
          {{ t('Title') }}
        </p>
      </div>
      <button
        type="button"
        class="rounded p-0.5 text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700"
        data-cy="verdict-feature-hint-close"
        @click="$emit('dismiss')"
      >
        <X class="size-4" />
      </button>
    </div>

    <p class="mt-2 w-full text-xs leading-4 text-black">
      {{ t('Body') }}
    </p>

    <div class="mt-2 flex w-full justify-end">
      <button
        type="button"
        class="inline-flex h-6 w-16 items-center justify-center rounded-[6px] bg-purple-600 px-1 py-1 text-xs
          font-medium leading-4 text-white shadow-[0_2px_4px_rgba(0,0,0,0.04)] transition-colors
          hover:bg-purple-700"
        data-cy="verdict-feature-hint-done"
        @click="$emit('dismiss')"
      >
        {{ t('Done') }}
      </button>
    </div>
  </div>
</template>
